


















































import {
  Component,
  Prop,
  Model,
  Watch,
  Ref,
  Vue as VueDecorator,
} from "vue-property-decorator";
import MultiSelectionDialogComponent from "./MultiSelectionDialog.vue";

@Component({
  components: {
    "multi-selection-dialog": MultiSelectionDialogComponent,
  },
})
export default class MultiSelectionPickerComponent<T> extends VueDecorator {
  isPickerOpen = false;

  @Ref("multiSelectionDialog")
  multiSelectionDialog!: MultiSelectionDialogComponent<T>;

  @Prop() options!: Array<T>;
  @Prop({ default: true }) showSelectNothingOption!: boolean;
  @Prop({ default: false }) readonly!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) hyDryClientConfig!: boolean;
  @Prop({ default: () => [] }) disabledOptions!: T[];
  /** Options that exclude each other: checking one of them unchecks the others. */
  @Prop({ default: () => [] }) exclusiveOptions!: T[];
  @Prop({
    default: () => {
      return [];
    },
  })
  errors!: Array<string>;

  @Model("change") current!: T[];
  @Prop() label!: string;
  @Prop() formatter!: (toFormat: T) => string;
  @Prop({ default: null }) newSelection!: T[] | null;

  changeTrigger = 1;

  selection: boolean[] = [];
  initialSelection: boolean[] = [];

  @Watch("isPickerOpen")
  async onPickerOpenStateChanged(
    isPickerOpen: boolean,
    wasPickerOpen: boolean
  ) {
    if (isPickerOpen && !wasPickerOpen) {
      const newSelection = await this.multiSelectionDialog.show({
        label: this.label,
        current: [...this.current],
        options: this.options,
        formatter: this.formatter,
        showSelectNothingOption: this.showSelectNothingOption,
        hyDryClientConfig: this.hyDryClientConfig,
        disabledOptions: this.disabledOptions,
        exclusiveOptions: this.exclusiveOptions,
      });

      this.$emit("change", newSelection);
      this.$emit("isValueSelected");
    }
  }

  get selectedOptions() {
    this.changeTrigger;

    const result: T[] = [];

    this.selection.forEach((value, index) => {
      if (value) {
        result.push(this.options[index]);
      }
    });

    return result;
  }

  get selectedString() {
    return this.current.map((value) => this.getString(value)).join(", ");
  }

  getString(item: T) {
    return this.formatter(item);
  }
}
